function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "16",
  viewBox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20 15.294c0-1.59-.654-3.115-1.818-4.24a6.32 6.32 0 00-4.39-1.756h-.14a10.87 10.87 0 01-7.027-2.74C4.709 4.842 3.51 2.51 3.255 0H0a13.052 13.052 0 001.675 5.47 13.537 13.537 0 003.881 4.3v5.524H20z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.467 6.98c1.688 0 3.056-1.352 3.056-3.02 0-1.667-1.368-3.019-3.056-3.019-1.687 0-3.055 1.352-3.055 3.02 0 1.667 1.368 3.018 3.055 3.018z",
  fill: "#fff"
})));